import { render } from "./viewRegisteredOnPeppol.vue?vue&type=template&id=3ce86950&scoped=true"
import script from "./viewRegisteredOnPeppol.vue?vue&type=script&lang=js"
export * from "./viewRegisteredOnPeppol.vue?vue&type=script&lang=js"

import "./viewRegisteredOnPeppol.vue?vue&type=style&index=0&id=3ce86950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce86950"]])

export default __exports__